import { render, staticRenderFns } from "./RespondersAddToSurveyInstance.vue?vue&type=template&id=1b460447&scoped=true"
import script from "./RespondersAddToSurveyInstance.vue?vue&type=script&lang=js"
export * from "./RespondersAddToSurveyInstance.vue?vue&type=script&lang=js"
import style0 from "./RespondersAddToSurveyInstance.vue?vue&type=style&index=0&id=1b460447&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b460447",
  null
  
)

export default component.exports